import { render } from "./LoginPage.vue?vue&type=template&id=081c6f84"
import script from "./LoginPage.vue?vue&type=script&lang=js"
export * from "./LoginPage.vue?vue&type=script&lang=js"

import "./LoginPage.vue?vue&type=style&index=0&id=081c6f84&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__